// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as DeRouteImport } from './routes/de'
import { Route as DuurzaamheidRouteImport } from './routes/duurzaamheid'
import { Route as EnRouteImport } from './routes/en'
import { Route as LocatieRouteImport } from './routes/locatie'
import { Route as PartnerAanmeldenRouteImport } from './routes/partner-aanmelden'
import { Route as PartnersRouteImport } from './routes/partners'
import { Route as PersRouteImport } from './routes/pers'
import { Route as PrivacybeleidRouteImport } from './routes/privacybeleid'
import { Route as ProgrammaRouteImport } from './routes/programma'
import { Route as TicketsRouteImport } from './routes/tickets'
import { Route as VertrouwenRouteImport } from './routes/vertrouwen'
import { Route as VrijwilligerRouteImport } from './routes/vrijwilliger'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as FilmsSlugRouteImport } from './routes/films.$slug'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin.index'
import { Route as AuthenticatedAdminBrandingRouteImport } from './routes/_authenticated/admin.branding'
import { Route as AuthenticatedAdminDuurzaamheidRouteImport } from './routes/_authenticated/admin.duurzaamheid'
import { Route as AuthenticatedAdminFilmsRouteImport } from './routes/_authenticated/admin.films'
import { Route as AuthenticatedAdminHomepageRouteImport } from './routes/_authenticated/admin.homepage'
import { Route as AuthenticatedAdminLocatieRouteImport } from './routes/_authenticated/admin.locatie'
import { Route as AuthenticatedAdminMediaRouteImport } from './routes/_authenticated/admin.media'
import { Route as AuthenticatedAdminSponsorsRouteImport } from './routes/_authenticated/admin.sponsors'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const DeRoute = DeRouteImport.update({
            id: '/de',path: '/de',getParentRoute: () => rootRouteImport
          })
const DuurzaamheidRoute = DuurzaamheidRouteImport.update({
            id: '/duurzaamheid',path: '/duurzaamheid',getParentRoute: () => rootRouteImport
          })
const EnRoute = EnRouteImport.update({
            id: '/en',path: '/en',getParentRoute: () => rootRouteImport
          })
const LocatieRoute = LocatieRouteImport.update({
            id: '/locatie',path: '/locatie',getParentRoute: () => rootRouteImport
          })
const PartnerAanmeldenRoute = PartnerAanmeldenRouteImport.update({
            id: '/partner-aanmelden',path: '/partner-aanmelden',getParentRoute: () => rootRouteImport
          })
const PartnersRoute = PartnersRouteImport.update({
            id: '/partners',path: '/partners',getParentRoute: () => rootRouteImport
          })
const PersRoute = PersRouteImport.update({
            id: '/pers',path: '/pers',getParentRoute: () => rootRouteImport
          })
const PrivacybeleidRoute = PrivacybeleidRouteImport.update({
            id: '/privacybeleid',path: '/privacybeleid',getParentRoute: () => rootRouteImport
          })
const ProgrammaRoute = ProgrammaRouteImport.update({
            id: '/programma',path: '/programma',getParentRoute: () => rootRouteImport
          })
const TicketsRoute = TicketsRouteImport.update({
            id: '/tickets',path: '/tickets',getParentRoute: () => rootRouteImport
          })
const VertrouwenRoute = VertrouwenRouteImport.update({
            id: '/vertrouwen',path: '/vertrouwen',getParentRoute: () => rootRouteImport
          })
const VrijwilligerRoute = VrijwilligerRouteImport.update({
            id: '/vrijwilliger',path: '/vrijwilliger',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const FilmsSlugRoute = FilmsSlugRouteImport.update({
            id: '/films/$slug',path: '/films/$slug',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminBrandingRoute = AuthenticatedAdminBrandingRouteImport.update({
            id: '/branding',path: '/branding',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminDuurzaamheidRoute = AuthenticatedAdminDuurzaamheidRouteImport.update({
            id: '/duurzaamheid',path: '/duurzaamheid',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminFilmsRoute = AuthenticatedAdminFilmsRouteImport.update({
            id: '/films',path: '/films',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminHomepageRoute = AuthenticatedAdminHomepageRouteImport.update({
            id: '/homepage',path: '/homepage',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminLocatieRoute = AuthenticatedAdminLocatieRouteImport.update({
            id: '/locatie',path: '/locatie',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminMediaRoute = AuthenticatedAdminMediaRouteImport.update({
            id: '/media',path: '/media',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSponsorsRoute = AuthenticatedAdminSponsorsRouteImport.update({
            id: '/sponsors',path: '/sponsors',getParentRoute: () => AuthenticatedAdminRoute
          })





const AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminBrandingRoute: AuthenticatedAdminBrandingRoute,AuthenticatedAdminDuurzaamheidRoute: AuthenticatedAdminDuurzaamheidRoute,AuthenticatedAdminFilmsRoute: AuthenticatedAdminFilmsRoute,AuthenticatedAdminHomepageRoute: AuthenticatedAdminHomepageRoute,AuthenticatedAdminLocatieRoute: AuthenticatedAdminLocatieRoute,AuthenticatedAdminMediaRoute: AuthenticatedAdminMediaRoute,AuthenticatedAdminSponsorsRoute: AuthenticatedAdminSponsorsRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute
}

const AuthenticatedAdminRouteWithChildren = AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AuthRoute: AuthRoute,DeRoute: DeRoute,DuurzaamheidRoute: DuurzaamheidRoute,EnRoute: EnRoute,LocatieRoute: LocatieRoute,PartnerAanmeldenRoute: PartnerAanmeldenRoute,PartnersRoute: PartnersRoute,PersRoute: PersRoute,PrivacybeleidRoute: PrivacybeleidRoute,ProgrammaRoute: ProgrammaRoute,TicketsRoute: TicketsRoute,VertrouwenRoute: VertrouwenRoute,VrijwilligerRoute: VrijwilligerRoute,FilmsSlugRoute: FilmsSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)